import keys from './modules/keys'
import themePicker from './modules/themePicker'

export default {
  keys: keys,
  themePicker: themePicker
}